import { useDropzone, type DropzoneOptions } from "react-dropzone";
import {
  DFY_IMAGE_ACCEPT,
  DFY_MAX_UPLOAD_BYTES,
} from "../dfy-order-form-uploads";

export function useDfyImageDropzone(
  onAdd: (files: File[]) => void,
  options: Pick<DropzoneOptions, "disabled" | "noClick" | "noKeyboard"> = {},
) {
  return useDropzone({
    ...options,
    accept: DFY_IMAGE_ACCEPT,
    multiple: true,
    maxSize: DFY_MAX_UPLOAD_BYTES,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onAdd(acceptedFiles);
      }
    },
  });
}
